import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Key_getInstance1eahaybkym4fk as Key_getInstance } from './CustomScalarAdapters.mjs';
import { ResponseParser_instance3qy7zb0dfcjcz as ResponseParser_instance } from './internal/ResponseParser.mjs';
import {
  JsonDataException2rdtm884tky1l as JsonDataException,
  ApolloNetworkException3denf70pfh242 as ApolloNetworkException,
  ApolloException16lek20l78zc3 as ApolloException,
} from '../exception/Exceptions.mjs';
import { Token_END_DOCUMENT_getInstance2vm30j439b0cy as Token_END_DOCUMENT_getInstance } from './json/JsonReader.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { uuid4al7pp0fcb8o5 as uuid4 } from '../../../../../uuid/com/benasher44/uuid/uuid.mjs';
import { Builder16nv925388a0q as Builder } from './ApolloResponse.mjs';
import { addSuppressedu5jwjfvsc039 as addSuppressed } from '../../../../../kotlin-kotlin-stdlib/kotlin/throwableExtensions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function toApolloResponse(_this__u8e3s4, operation, requestUuid, customScalarAdapters, deferredFragmentIdentifiers) {
  requestUuid = requestUuid === VOID ? null : requestUuid;
  customScalarAdapters = customScalarAdapters === VOID ? Key_getInstance().f45_1 : customScalarAdapters;
  deferredFragmentIdentifiers = deferredFragmentIdentifiers === VOID ? null : deferredFragmentIdentifiers;
  // Inline function 'okio.use' call
  var thrown = null;
  var tmp;
  try {
    var tmp_0;
    try {
      // Inline function 'kotlin.also' call
      var this_0 = ResponseParser_instance.s46(_this__u8e3s4, operation, requestUuid, customScalarAdapters, deferredFragmentIdentifiers);
      if (!_this__u8e3s4.w3x().equals(Token_END_DOCUMENT_getInstance())) {
        throw JsonDataException().x46('Expected END_DOCUMENT but was ' + _this__u8e3s4.w3x().toString());
      }
      tmp_0 = this_0;
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var throwable = $p;
        var tmp1_requestUuid = requestUuid == null ? uuid4() : requestUuid;
        tmp_1 = Builder().u41(operation, tmp1_requestUuid).z41(wrapIfNeeded(throwable)).a42(true).i37();
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    tmp = tmp_0;
  } catch ($p_0) {
    var tmp_2;
    if ($p_0 instanceof Error) {
      var t = $p_0;
      thrown = t;
      tmp_2 = null;
    } else {
      throw $p_0;
    }
    tmp = tmp_2;
  }
  finally {
    try {
      if (_this__u8e3s4 == null)
        null;
      else {
        _this__u8e3s4.l6();
      }
    } catch ($p_1) {
      if ($p_1 instanceof Error) {
        var t_0 = $p_1;
        if (thrown == null) {
          thrown = t_0;
        } else {
          addSuppressed(thrown, t_0);
        }
      } else {
        throw $p_1;
      }
    }
  }
  var result = tmp;
  if (!(thrown == null))
    throw thrown;
  return result;
}
function parseResponse(_this__u8e3s4, operation, requestUuid, customScalarAdapters, deferredFragmentIdentifiers) {
  requestUuid = requestUuid === VOID ? null : requestUuid;
  customScalarAdapters = customScalarAdapters === VOID ? Key_getInstance().f45_1 : customScalarAdapters;
  deferredFragmentIdentifiers = deferredFragmentIdentifiers === VOID ? null : deferredFragmentIdentifiers;
  var tmp;
  try {
    tmp = ResponseParser_instance.s46(_this__u8e3s4, operation, requestUuid, customScalarAdapters, deferredFragmentIdentifiers);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var throwable = $p;
      var tmp1_requestUuid = requestUuid == null ? uuid4() : requestUuid;
      tmp_0 = Builder().u41(operation, tmp1_requestUuid).z41(wrapIfNeeded(throwable)).a42(true).i37();
    } else {
      throw $p;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function wrapIfNeeded(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof ApolloException()) {
    tmp = _this__u8e3s4;
  } else {
    tmp = ApolloNetworkException().d47('Error while reading JSON response', _this__u8e3s4);
  }
  return tmp;
}
//region block: exports
export {
  parseResponse as parseResponse2l74cu4whks78,
  toApolloResponse as toApolloResponse9u5mcqg84l2p,
};
//endregion

//# sourceMappingURL=Operations.mjs.map
